import { render, staticRenderFns } from "./Fire.vue?vue&type=template&id=72b799ea"
import script from "./Fire.vue?vue&type=script&lang=js"
export * from "./Fire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports